export enum JobType {
  GENERATE_COUPON_CODES = 'GENERATE_COUPON_CODES',
  CREATE_GUEST_INVITATIONS = 'CREATE_GUEST_INVITATIONS',
  EXPORT = 'EXPORT',
  GENERATE_GUEST_TICKETS = 'GENERATE_GUEST_TICKETS',
}

export enum JobNotificationStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum JobStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
